<template>
    <modal :title="title" :titleIcon="titleIcon" ref="modal" class="quick-create-form">
        <template slot="body">
            <form name="mainForm">
                <div class="row">
                    <div class="col-sm-12" v-for="field in prepareFields">
                        <component :is="getComponent(field)" v-bind="field" v-model="field.value" :maxLength="field['max-length']"
                                   :numberLength="field['number-length']"
                                   @changed="componentValueChanged($event, field)" @input="changeSubmitAuthority($event, field)" @validationCompleted="onValidationCompleted($event, field)"></component>
                    </div>
                    <div>

                    </div>
                </div>
            </form>
        </template>
        <template slot="footer" :class="{'text-center': true}">
            <div class="w-100 text-right">
                <button type="submit" class="btn quick-create-form-btn-submit text-uppercase" @click="onSubmit" :disabled="!hasSubmitAuthorization"><i v-if="showLoader" class="zmdi zmdi-refresh zmdi-hc-fw rotating"></i> {{ submitButtonLabel }}</button>
                <button type="submit" class="btn quick-create-form-btn-cancel text-uppercase" @click="close"><i v-if="loader" class="zmdi zmdi-refresh zmdi-hc-fw rotating"></i> {{ cancelButtonLabel }}</button>
            </div>
        </template>
    </modal>
</template>

<script>
    import Modal from '@/components/Modal'
    import MainForm from '@/components/MainForm'
    import AppHelper from "../helper";

    export default {
        extends: MainForm,

        data() {
            return {
                hasError: false,
                attachments: false,
                hasSubmitAuthorization: false,
                hasValidationErrorOnAttachments: false
            }
        },

        props: {
            submitButtonLabel: {default: 'Soumettre'},
            cancelButtonLabel: {default: 'Annuler'},
            showLoader: {
                type: Boolean,
                default: false
            },
            hasAttachment: false
        },

        components: {
            'modal': Modal
        },

        computed: {
            prepareFields() {
                if(!AppHelper.empty(this.mainFields)){
                    this.mainFields.forEach(function(field){
                        field['isFloat'] = true
                    });
                }

                return this.mainFields
            }
        },

        methods: {
            async onSubmit() {
                await this.$validator.validateAll()
                this.hasError = this.errors.any()

                if(!this.hasError){
                    this.$emit('form-submited', {'formData': $('form', this.$el).serializeFormData(),
                        'attachments': this.attachments})
                }

                return
            },

            componentValueChanged(value, field) {
                if(field.type === 'attachment'){
                    this.attachments = value
                }
            },

            onValidationCompleted(validationFailed, field) {
                if(field.type === 'attachment'){
                    this.hasValidationErrorOnAttachments = validationFailed
                    this.changeSubmitAuthority()
                }
            },

            //TODO: reuse isReadyForSubmit
            changeSubmitAuthority(value, field) {
                let submitAuthorization = true
                let serializeData = $('form', this.$el).serializeFormData()

                this.mainFields.forEach(function(field){
                    if(field.mandatory && AppHelper.empty(serializeData[field.name])){
                        submitAuthorization = false
                    }
                });

                this.hasSubmitAuthorization = submitAuthorization && !this.hasValidationErrorOnAttachments
            },

            close() {
                this.$refs.modal.close()
            }
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/components/_quickcreateform.scss";</style>